export default __webpack_public_path__ + "static/media/pic9.5b46fb30.jpg";